module.exports = __webpack_public_path__ + "img/error-security-mp.438ef8c8.png";